import {useCallback} from 'react';
import useLocalization from '../../../../../hooks/useLocalization';
import {PieLabelRenderProps, PieLabel} from 'recharts';
import renderEmphasis from '../../../../../components/v2/sections/fortnite-games/game-xp/Emphasis';
import {ActivationsColorPalette} from '../../../../../constants/fortnite-games/ColorSwatch';
import {GameXpDataItem} from '../../../../../reducers/fortnite-game/gameXp.reducer';
import {getColorIndex} from '../utils';

const CODES = {
    totalNumber: 'epic.affiliate.fortnite_games.xp.emphasis.total_number',
    activations: 'epic.affiliate.fortnite_games.xp.emphasis.activations',
    totalActivations: 'epic.affiliate.fortnite_games.xp.emphasis.total_activations'
};

interface UseEmphasisDataProps {
    data: GameXpDataItem;
    total: number;
    activeIndex: number;
}

interface EmphasisDataItem {
    [key: string]: string | number;
}

interface UseEmphasisState {
    data: EmphasisDataItem[];
    renderPieEmphasis: (props: PieLabelRenderProps) => PieLabel<any>;
}

const useEmphasisData = ({
    data: {activations = []},
    total,
    activeIndex
}: UseEmphasisDataProps): UseEmphasisState => {
    const getMessage = useLocalization();

    const title = getMessage(CODES.totalNumber);
    const description =
        activeIndex >= 0 ? getMessage(CODES.activations) : getMessage(CODES.totalActivations);

    const data = activations.map(({name, activations}, index) => ({
        name,
        value: (activations / total) * 100,
        color: ActivationsColorPalette[getColorIndex(index)]
    }));

    const renderPieEmphasis = useCallback(
        props => renderEmphasis({...props, activeIndex, total, title, description}),
        [renderEmphasis, activeIndex, total]
    );

    return {
        data,
        renderPieEmphasis
    };
};

export default useEmphasisData;
